import * as Eff from 'redux-saga/effects';
import { FETCH_AUDIT } from '../components/audit/audit-actions';
import { fetchAuditStartWorker } from '../components/audit/audit-sagas';
import {
  FETCH_DOCTORS,
  FETCH_DOCTOR_BY_ID,
  UPDATE_DOCTOR,
  UPLOAD_DOCTOR_PHOTO,
} from '../components/doctors/doctors-actions';
import {
  fetchDoctorByIdStartWorker,
  fetchDoctorsStartWorker,
  updateDoctorStartWorker,
  uploadDoctorPhotoStartWorker,
} from '../components/doctors/doctors-sagas';
import { tabsExportSaga } from '../components/export/export-sagas';
import { EXPORT_FILE, IMPORT_FILE, UPDATE_VALIDATED_IMPORT } from '../components/header/header-actions';
import {
  exportFileStartWorker,
  importBulkUpdateFileStartWorker,
  updateValidatedImportStartWorker,
} from '../components/header/header-sagas';
import {
  DELETE_FILE,
  DOWNLOAD_FILE,
  DOWNLOAD_SNAPSHOT_FILE,
  DOWNLOAD_VALIDATE_FILE,
  FETCH_IMPORT_DETAILS,
  PROCESS_IMPORT,
  VALIDATE_FILE,
} from '../components/import/import-actions';
import {
  deleteResourceStartWorker,
  downloadFileStartWorker,
  downloadSnapshotFileStartWorker,
  downloadValidatedFileStartWorker,
  getImportsStartWorker,
  processImportStartWorker,
  validateFileStartWorker,
} from '../components/import/import-sagas';
import { FETCH_LOCATIONS_COORDINATES } from '../components/map/map-actions';
import { fetchLocationsCoordinatesStartWorker } from '../components/map/map-sagas';
import {
  CREATE_BILLING,
  CREATE_DISTRICT,
  CREATE_LOCATION,
  CREATE_REGION,
  DELETE_LOCATION,
  DELETE_VENDOR,
  FETCH_CONTACTS,
  FETCH_DISTRICTS,
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_FOR_SEARCH,
  FETCH_LOCATION_ASSIGNMENT_COUNT,
  FETCH_OFFICE_LIST,
  FETCH_REGIONS,
  REGION_DISTRICT_BULK_UPDATE,
  REGION_DISTRICT_BULK_UPDATE_STAFF,
  SAVE_VENDOR_ACCOUNTS,
  SEARCH_DISTRICTS,
  UNASSIGN_STAFF,
  UPDATE_CONTACT,
  FETCH_LOCATION_VENDOR_DATA,
} from '../components/offices/offices-actions';
import {
  bulkUpdateStaffStartWorker,
  createBillingStartWorker,
  createDistrictStartWorker,
  createLocationStartWorker,
  createRegionStartWorker,
  deleteLocationStartWorker,
  deleteVendorStartWorker,
  fetchContactsStartWorker,
  fetchDistrictsStartWorker,
  fetchLocationAssignmentCountStartWorker,
  fetchLocationsForSearchStartWorker,
  fetchLocationsStartWorker,
  fetchOfficeListStartWorker,
  fetchRegionsStartWorker,
  regionDistrictBulkUpdateStartWorker,
  saveVendorAccountStartWorker,
  searchDistrictsByAreaStartWorker,
  unassignStuffStartWorker,
  updateContactStartWorker,
  fetchLocationVendorDataStartWorker,
} from '../components/offices/offices-sagas';
import {
  FETCH_ACTIVITY_STATISTICS,
  FETCH_DOCTORS_STATISTICS,
  FETCH_OFFICES_STATISTICS,
} from '../components/statistics/statistics-actions';
import {
  fetchActivityStatisticsStartWorker,
  fetchDoctorsStatisticsStartWorker,
  fetchOfficesStatisticsStartWorker,
} from '../components/statistics/statistics-sagas';
import { CREATE_VENDOR, FETCH_VENDORS, SEARCH_VENDORS } from '../components/vendors/vendors-actions';
import {
  createVendorStartWorker,
  fetchVendorStartWorker,
  searchVendorStartWorker,
} from '../components/vendors/vendors-sagas';
import {
  CREATE_BRANDED_FIXTURE,
  FETCH_BRANDED_FIXTURES,
  SEARCH_BRANDED_FIXTURES,
  UPDATE_BRANDED_FIXTURE,
  FETCH_COLLECTIONS,
  FETCH_VENDOR_COLLECTION_LISTINGS,
  FETCH_OFFICE_FIXTURES,
  FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES,
  SAVE_OFFICE_FIXTURES,
} from '../components/branded-fixtures/branded-fixtures-actions';
import {
  createBrandedFixtureStartWorker,
  fetchBrandedFixturesStartWorker,
  searchBrandedFixturesStartWorker,
  updateBrandedFixtureStartWorker,
  fetchCollectionsStartWorker,
  fetchVendorCollectionListingsStartWorker,
  fetchOfficeFixturesStartWorker,
  fetchDefaultOfficeBrandedFixturesStartWorker,
  saveOfficeFixturesStartWorker,
} from '../components/branded-fixtures/branded-fixtures-sagas';
import { CREATE_ADDRESS, DELETE_ADDRESS, FETCH_ADDRESS } from './address/address-actions';
import { createAddressStartWorker, deleteAddressStartWorker, fetchAddressStartWorker } from './address/address-sagas';
import { FETCH_ALL_SPECIALTIES, FETCH_EQUIPMENT } from './common/common-actions';
import { fetchAllSpecialtiesStartWorker, fetchEquipmentStartWorker } from './common/common-sagas';
import {
  CREATE_SCHEDULE,
  FETCH_EFFECTIVE_DATES,
  FETCH_SCHEDULES,
  FETCH_SCHEDULES_MODEL_NAMES,
  FETCH_SCHEDULE_MODELS,
} from './schedule/schedule-actions';
import {
  createSchedulesStartWorker,
  fetchEffectiveDatesStartWorker,
  fetchScheduleModelNamesStartWorker,
  fetchScheduleModelsStartWorker,
  fetchSchedulesStartWorker,
} from './schedule/schedule-sagas';
import {
  FETCH_ADMIN_EMAILS,
  FETCH_EMAIL_GROUPS,
  FETCH_TAB_VISIBILITY,
  FETCH_USER_EMAIL_GROUPS,
  FETCH_USER_POSITIONS,
  UPDATE_USER_EMAIL_GROUPS,
} from './user/user-actions';
import {
  fetchAdminEmailsStartWorker,
  fetchEmailGroupsStartWorker,
  fetchTabVisibilityWorker,
  fetchUserEmailGroupsStartWorker,
  fetchUserPositionsStartWorker,
  updateUserEmailGroupsStartWorker,
} from './user/user-sagas';

import {
  ACCEPT_HOO_REQUEST,
  DELETE_HOO_REQUEST,
  FETCH_LOCATIONS_FOR_REQUESTOR,
  FETCH_UNPLANNED_LOCATIONS,
  FETCH_REQUESTORS,
  FETCH_REQUEST_REASONS,
  FETCH_REQUEST_TYPES,
  REJECT_HOO_REQUEST,
  SAVE_HOO_REQUEST,
  SEARCH_HOO,
  EXPORT_HOO_REQUESTS,
} from '../components/HooAccommodations/actions';
import {
  acceptHooAccommodationStartWorker,
  deleteHooAccommodationStartWorker,
  fetchLocationsForRequestorStartWorker,
  fetchUnplannedLocationsStartWorker,
  fetchRequestorsStartWorker,
  fetchRequestReasonsStartWorker,
  fetchRequestTypesStartWorker,
  rejectHooAccommodationStartWorker,
  saveHooAccommodationStartWorker,
  searchHooStartWorker,
  exportHooRequestsStartWorker,
} from '../components/HooAccommodations/sagas';
import {
  ADD_ROLE,
  FETCH_PERMISSIONS_LIST,
  FETCH_PERMISSION_MAPPINGS,
  FETCH_ROLES,
  FETCH_ROLE_PERMISSIONS,
  FETCH_ROLE_USERS,
  MAP_ROLE_ADUSER,
  MAP_ROLE_PERMISSION,
  UNMAP_ROLE_ADUSER,
  UNMAP_ROLE_PERMISSION,
} from '../components/UserRoleConfiguration/actions';
import {
  addRoleWorker,
  fetchPermissionMappingsWorker,
  fetchPermissionsListWorker,
  fetchRolePermissionsWorker,
  fetchRoleUsersWorker,
  fetchRolesWorker,
  mapRoleAdUserWorker,
  mapRolePermissionWorker,
  unmapRoleAdUserWorker,
  unmapRolePermissionWorker,
} from '../components/UserRoleConfiguration/sagas';
import { updateHolidayScheduleStartWorker } from '../components/HolidaySchedule/saga';
import { UPDATE_HOLIDAY_SCHEDULE } from '../components/HolidaySchedule/actions';
import { FETCH_CALL_FORWARDING, CANCEL_CALL_FORWARDING } from '../components/CallForwardingSnapshot/actions';
import { fetchCallForwardingWorker, cancelCallForwardingWorker } from '../components/CallForwardingSnapshot/sagas';

const takeEvery: any = Eff.takeEvery;
const takeLatest: any = Eff.takeLatest;

export default function* rootSaga() {
  yield takeEvery(FETCH_ADDRESS, fetchAddressStartWorker);
  yield takeEvery(CREATE_ADDRESS, createAddressStartWorker);
  yield takeEvery(DELETE_ADDRESS, deleteAddressStartWorker);

  yield takeEvery(FETCH_LOCATIONS, fetchLocationsStartWorker);
  yield takeEvery(FETCH_LOCATION_VENDOR_DATA, fetchLocationVendorDataStartWorker);
  yield takeEvery(CREATE_LOCATION, createLocationStartWorker);
  yield takeEvery(DELETE_LOCATION, deleteLocationStartWorker);

  yield takeEvery(FETCH_AUDIT, fetchAuditStartWorker);

  yield takeEvery(EXPORT_FILE, exportFileStartWorker);
  yield takeEvery(IMPORT_FILE, importBulkUpdateFileStartWorker);
  yield takeEvery(UPDATE_VALIDATED_IMPORT, updateValidatedImportStartWorker);
  yield takeEvery(FETCH_USER_EMAIL_GROUPS, fetchUserEmailGroupsStartWorker);
  yield takeEvery(FETCH_EMAIL_GROUPS, fetchEmailGroupsStartWorker);
  yield takeEvery(UPDATE_USER_EMAIL_GROUPS, updateUserEmailGroupsStartWorker);
  yield takeEvery(FETCH_ADMIN_EMAILS, fetchAdminEmailsStartWorker);

  yield takeEvery(FETCH_REGIONS, fetchRegionsStartWorker);
  yield takeEvery(FETCH_DISTRICTS, fetchDistrictsStartWorker);
  yield takeEvery(SEARCH_DISTRICTS, searchDistrictsByAreaStartWorker);

  yield takeEvery(FETCH_VENDORS, fetchVendorStartWorker);
  yield takeEvery(SEARCH_VENDORS, searchVendorStartWorker);
  yield takeEvery(CREATE_VENDOR, createVendorStartWorker);
  yield takeEvery(DELETE_VENDOR, deleteVendorStartWorker);

  yield takeLatest(FETCH_OFFICE_LIST, fetchOfficeListStartWorker);

  yield takeEvery(SAVE_VENDOR_ACCOUNTS, saveVendorAccountStartWorker);

  yield takeEvery(FETCH_LOCATION_ASSIGNMENT_COUNT, fetchLocationAssignmentCountStartWorker);
  yield takeEvery(UPDATE_CONTACT, updateContactStartWorker);
  yield takeEvery(FETCH_CONTACTS, fetchContactsStartWorker);

  yield takeEvery(CREATE_REGION, createRegionStartWorker);
  yield takeEvery(CREATE_DISTRICT, createDistrictStartWorker);
  yield takeEvery(REGION_DISTRICT_BULK_UPDATE, regionDistrictBulkUpdateStartWorker);

  yield takeEvery(CREATE_BILLING, createBillingStartWorker);

  yield takeEvery(FETCH_LOCATIONS_COORDINATES, fetchLocationsCoordinatesStartWorker);

  yield takeEvery(FETCH_LOCATIONS_FOR_SEARCH, fetchLocationsForSearchStartWorker);

  yield takeEvery(FETCH_SCHEDULES, fetchSchedulesStartWorker);
  yield takeEvery(CREATE_SCHEDULE, createSchedulesStartWorker);
  yield takeEvery(FETCH_EFFECTIVE_DATES, fetchEffectiveDatesStartWorker);
  yield takeEvery(REGION_DISTRICT_BULK_UPDATE_STAFF, bulkUpdateStaffStartWorker);
  yield takeEvery(UNASSIGN_STAFF, unassignStuffStartWorker);

  yield takeEvery(FETCH_SCHEDULES_MODEL_NAMES, fetchScheduleModelNamesStartWorker);
  yield takeEvery(FETCH_SCHEDULE_MODELS, fetchScheduleModelsStartWorker);

  yield takeEvery(FETCH_DOCTORS, fetchDoctorsStartWorker);
  yield takeEvery(FETCH_DOCTOR_BY_ID, fetchDoctorByIdStartWorker);
  yield takeEvery(UPDATE_DOCTOR, updateDoctorStartWorker);
  yield takeEvery(UPLOAD_DOCTOR_PHOTO, uploadDoctorPhotoStartWorker);
  yield takeEvery(FETCH_ALL_SPECIALTIES, fetchAllSpecialtiesStartWorker);
  yield takeEvery(FETCH_EQUIPMENT, fetchEquipmentStartWorker);

  yield takeEvery(FETCH_OFFICES_STATISTICS, fetchOfficesStatisticsStartWorker);
  yield takeEvery(FETCH_DOCTORS_STATISTICS, fetchDoctorsStatisticsStartWorker);
  yield takeEvery(FETCH_ACTIVITY_STATISTICS, fetchActivityStatisticsStartWorker);
  yield takeEvery(FETCH_TAB_VISIBILITY, fetchTabVisibilityWorker);

  yield takeEvery(FETCH_IMPORT_DETAILS, getImportsStartWorker);
  yield takeEvery(VALIDATE_FILE, validateFileStartWorker);
  yield takeEvery(PROCESS_IMPORT, processImportStartWorker);
  yield takeEvery(DOWNLOAD_FILE, downloadFileStartWorker);
  yield takeEvery(DOWNLOAD_VALIDATE_FILE, downloadValidatedFileStartWorker);
  yield takeEvery(DOWNLOAD_SNAPSHOT_FILE, downloadSnapshotFileStartWorker);
  yield takeEvery(DELETE_FILE, deleteResourceStartWorker);

  yield takeEvery(SEARCH_HOO, searchHooStartWorker);
  yield takeEvery(FETCH_USER_POSITIONS, fetchUserPositionsStartWorker);
  yield takeEvery(FETCH_REQUESTORS, fetchRequestorsStartWorker);
  yield takeEvery(FETCH_LOCATIONS_FOR_REQUESTOR, fetchLocationsForRequestorStartWorker);
  yield takeEvery(FETCH_UNPLANNED_LOCATIONS, fetchUnplannedLocationsStartWorker);

  yield takeEvery(FETCH_REQUEST_REASONS, fetchRequestReasonsStartWorker);
  yield takeEvery(FETCH_REQUEST_TYPES, fetchRequestTypesStartWorker);

  yield takeEvery(DELETE_HOO_REQUEST, deleteHooAccommodationStartWorker);
  yield takeEvery(SAVE_HOO_REQUEST, saveHooAccommodationStartWorker);
  yield takeEvery(ACCEPT_HOO_REQUEST, acceptHooAccommodationStartWorker);
  yield takeEvery(REJECT_HOO_REQUEST, rejectHooAccommodationStartWorker);
  yield takeEvery(EXPORT_HOO_REQUESTS, exportHooRequestsStartWorker);

  //HolidaySchedule
  yield takeEvery(UPDATE_HOLIDAY_SCHEDULE, updateHolidayScheduleStartWorker);
  // User Role Configuration
  yield takeEvery(FETCH_ROLES, fetchRolesWorker);
  yield takeEvery(FETCH_PERMISSIONS_LIST, fetchPermissionsListWorker);
  yield takeEvery(FETCH_ROLE_PERMISSIONS, fetchRolePermissionsWorker);
  yield takeEvery(FETCH_ROLE_USERS, fetchRoleUsersWorker);
  yield takeEvery(FETCH_PERMISSION_MAPPINGS, fetchPermissionMappingsWorker);
  yield takeEvery(MAP_ROLE_PERMISSION, mapRolePermissionWorker);
  yield takeEvery(UNMAP_ROLE_PERMISSION, unmapRolePermissionWorker);
  yield takeEvery(MAP_ROLE_ADUSER, mapRoleAdUserWorker);
  yield takeEvery(UNMAP_ROLE_ADUSER, unmapRoleAdUserWorker);
  yield takeEvery(ADD_ROLE, addRoleWorker);
  // Call Forwarding
  yield takeLatest(FETCH_CALL_FORWARDING, fetchCallForwardingWorker);
  yield takeEvery(CANCEL_CALL_FORWARDING, cancelCallForwardingWorker);
  // Branded Fixtures
  yield takeEvery(FETCH_BRANDED_FIXTURES, fetchBrandedFixturesStartWorker);
  yield takeEvery(SEARCH_BRANDED_FIXTURES, searchBrandedFixturesStartWorker);
  yield takeEvery(CREATE_BRANDED_FIXTURE, createBrandedFixtureStartWorker);
  yield takeEvery(UPDATE_BRANDED_FIXTURE, updateBrandedFixtureStartWorker);
  yield takeEvery(FETCH_COLLECTIONS, fetchCollectionsStartWorker);
  yield takeEvery(FETCH_VENDOR_COLLECTION_LISTINGS, fetchVendorCollectionListingsStartWorker);
  yield takeEvery(FETCH_OFFICE_FIXTURES, fetchOfficeFixturesStartWorker);
  yield takeLatest(FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES, fetchDefaultOfficeBrandedFixturesStartWorker);
  yield takeEvery(SAVE_OFFICE_FIXTURES, saveOfficeFixturesStartWorker);
  yield Eff.fork(tabsExportSaga);
}
